/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { NotificationEmailDeliveriesControllerFindOneQueryResponse, NotificationEmailDeliveriesControllerFindOnePathParams, NotificationEmailDeliveriesControllerFindOneQueryParams, NotificationEmailDeliveriesControllerFindOne400, NotificationEmailDeliveriesControllerFindOne401, NotificationEmailDeliveriesControllerFindOne403, NotificationEmailDeliveriesControllerFindOne404 } from "../../models/notificationEmailDeliveriesController/NotificationEmailDeliveriesControllerFindOne";

function getNotificationEmailDeliveriesControllerFindOneUrl(id: NotificationEmailDeliveriesControllerFindOnePathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/notification-email-deliveries/${id}` as const }  
  return res
}

/**
 * @summary Get one notification email delivery
 * {@link /api/v1/notification-email-deliveries/:id}
 */
export async function notificationEmailDeliveriesControllerFindOne(id: NotificationEmailDeliveriesControllerFindOnePathParams["id"], params?: NotificationEmailDeliveriesControllerFindOneQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<NotificationEmailDeliveriesControllerFindOneQueryResponse, ResponseErrorConfig<NotificationEmailDeliveriesControllerFindOne400 | NotificationEmailDeliveriesControllerFindOne401 | NotificationEmailDeliveriesControllerFindOne403 | NotificationEmailDeliveriesControllerFindOne404>, unknown>({ method : "GET", url : getNotificationEmailDeliveriesControllerFindOneUrl(id).url.toString(), params, ... requestConfig })  
  return res.data
}